var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5237L18 3.02368",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 5.219C14.4751 3.88537 12.6932 3.09951 10.8118 3.01696C8.93041 2.93442 7.08657 3.5612 5.64525 4.77326C4.20392 5.98531 3.27016 7.69431 3.02876 9.56198C2.78736 11.4297 3.25593 13.3199 4.34172 14.8586C5.42751 16.3973 7.05139 17.4723 8.89195 17.8708C10.7325 18.2693 12.6556 17.9623 14.2806 17.0106C15.9057 16.0588 17.1142 14.5317 17.6669 12.7314C18.2197 10.9312 18.0765 8.98901 17.2656 7.28931",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1485 7.87525C12.5291 7.25764 11.713 6.87648 10.8418 6.798C9.97068 6.71952 9.09957 6.94866 8.3798 7.44563C7.66003 7.94261 7.13708 8.676 6.9018 9.51843C6.66651 10.3609 6.73374 11.2591 7.09183 12.0571C7.44991 12.8551 8.07621 13.5025 8.86195 13.8868C9.64768 14.2711 10.5432 14.368 11.393 14.1607C12.2427 13.9534 12.993 13.455 13.5135 12.752C14.034 12.0491 14.2918 11.186 14.2422 10.3128",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget2);
export default __webpack_public_path__ + "static/media/Target2.ae994d7a987d469e64429a6548d4641f.svg";
export { ForwardRef as ReactComponent };